import { render } from "./App.vue?vue&type=template&id=1284106a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1284106a&lang=scss"

import exportComponent from "/home/vsts/work/1/s/Tenisu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__